import { City } from './index';

export const CITIES: City[] = [
  {"name": "Ahero", "alias": "Ahr"},
  {"name": "Alema", "alias": "Alm"},
  {"name": "Amagoro", "alias": "Amgr"},
  {"name": "Area", "alias": "Ara"}
];
